import React from 'react';
import styled from 'styled-components';
import { IMG_SUCCESS_BG } from '@assets';

const Card = styled.div`
border-radius: 24px;
display: flex;
flex-direction: column;
`;

const Title = styled.div`
background: ${props => props.theme.backgroundColor};
padding: 24px;
text-align: center;
font-size: 24px;
font-weight: 700;
color: ${props => props.theme.primaryColor};
border-top-right-radius: 24px;
border-top-left-radius: 24px;

border-image-source: ${props => `linear-gradient(to left, #fff, ${props.theme.primaryColor}, #fff)`};
border-bottom: 1px solid;
border-image-slice: 1;
`;

const BodyImage = styled.img.attrs({
    alt: 'bgimg',
    src: IMG_SUCCESS_BG,
})`
width: 100%;
border-bottom-left-radius: 24px;
border-bottom-right-radius: 24px;
aspect-ratio: 13 / 7;
`;

const SuccessCard = ({
    title,
}) => {
    return (
        <Card>
            <Title>{title}</Title>
            <BodyImage />
        </Card>
    )
}

export default SuccessCard